var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 9.8818C11.5224 8.8136 10.7586 8 9.51815 8C8.27774 8 7.4668 8.8136 7.4668 9.8818C7.4668 10.9279 8.25377 11.7649 9.47108 11.7649H9.49426C10.7586 11.7649 11.546 10.9279 11.546 9.8818Z",
    fill: "#0D3475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3072 13.252H7.68121V24.1464H11.3072V13.252Z",
    fill: "#0D3475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2089 12.9961C22.5949 12.9961 24.3837 14.5535 24.3837 17.8998L24.3836 24.1464H20.7578V18.3178C20.7578 16.8538 20.2331 15.8548 18.9205 15.8548C17.9187 15.8548 17.3221 16.5283 17.06 17.1788C16.9641 17.4119 16.9406 17.7367 16.9406 18.0623V24.1467H13.3142C13.3142 24.1467 13.362 14.2745 13.3142 13.2522H16.9406V14.7953C17.4218 14.0535 18.2838 12.9961 20.2089 12.9961Z",
    fill: "#0D3475"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.28d14447.svg";
export { ForwardRef as ReactComponent };